// LocalStorage 封装工具

const STORAGE_PREFIX = 'nexusinflu_';

export const storage = {
  // 获取
  get: <T>(key: string): T | null => {
    try {
      const item = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (!item) return null;
      return JSON.parse(item) as T;
    } catch {
      return null;
    }
  },

  // 设置
  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value));
    } catch (error) {
      console.error('Storage set error:', error);
    }
  },

  // 删除
  remove: (key: string): void => {
    try {
      localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    } catch (error) {
      console.error('Storage remove error:', error);
    }
  },

  // 清空
  clear: (): void => {
    try {
      // 只清空带有前缀的项
      Object.keys(localStorage)
        .filter((key) => key.startsWith(STORAGE_PREFIX))
        .forEach((key) => localStorage.removeItem(key));
    } catch (error) {
      console.error('Storage clear error:', error);
    }
  },
};

// 快捷方法
export const getToken = (): string | null => storage.get<string>('token');
export const setToken = (token: string): void => storage.set('token', token);
export const removeToken = (): void => storage.remove('token');

export const getRefreshToken = (): string | null => storage.get<string>('refresh_token');
export const setRefreshToken = (token: string): void => storage.set('refresh_token', token);
export const removeRefreshToken = (): void => storage.remove('refresh_token');
